import template from './gates-type.jade';
import gatesTypeItems from '../../../enums/gates-type';

export default angular
  .module('cian.addForm.gatesType', ['cian.addForm.fieldTypeDropdown'])
  .directive('cianAfAboutObjectGatesType', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = gatesTypeItems;
    },
    controllerAs: 'gatesType',
    template,
  })).name;
